var SENTRY_RELEASE;SENTRY_RELEASE={name: "Fluencia", version: "1.0.0"};